// extracted by mini-css-extract-plugin
export default {"HomeworkDetail":"HomeworkDetail_HomeworkDetail__zhy04","HomeworkDetailDescr":"HomeworkDetail_HomeworkDetailDescr__02zgV"};